import axios from 'axios'
const baseURL = 'https://viacep.com.br/ws'

export const http = axios.create({
  baseURL: baseURL,
})

const expandedUF = {
  AC: 'Acre',
  AL: 'Alagoas',
  AM: 'Amazonas',
  AP: 'Amapá',
  BA: 'BAHIA',
  CE: 'Ceará',
  DF: 'Distrito Federal',
  ES: 'Espírito Santo',
  GO: 'Goiás',
  MA: 'Maranhão',
  MG: 'Minas Gerais',
  MS: 'Mato Grosso do Sul',
  MT: 'Mato Grosso',
  PA: 'Pará',
  PB: 'Paraíba',
  PE: 'Pernambuco',
  PI: 'Piauí',
  PR: 'Paraná',
  RJ: 'Rio de Janeiro',
  RN: 'Rio Grande do Norte',
  RO: 'Rondônia',
  RR: 'Roraima',
  RS: 'Rio Grande do Sul',
  SC: 'Santa Catarina',
  SE: 'Sergipe',
  SP: 'São Paulo',
  TO: 'Tocantins',
}

export default {
  async find(cep) {
    const formattedCEP = this._clearCEP(cep)
    try {
      const response = await http.get(`/${formattedCEP}/json`)
      return this._dataIn(response.data)
    } catch (error) {
      console.error('Erro ao buscar CEP:', error)
      throw error
    }
  },

  _clearCEP(cep) {
    return cep.replace(/-/g, '')
  },

  _dataIn(data) {
    if (!data.erro) {
      data.state = expandedUF[data.uf]
      delete data.uf
    }
    return data
  },
}
